// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-wrapper {
  display: flex;
  width: 100%;
  min-height: 100vh;
  align-items: stretch;
}


.content-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
  background-color: #f8f9fa;
}


header {
  width: 100%;
  z-index: 10;
}


.main-content {
  flex: 1 1;
  padding:20px; 
  overflow-y: auto;
  background: white;
}


.sidenav {
  width: 260px;
  height: auto;
  position: sticky;
  top: 0;
  background: #0C1831;
  flex-shrink: 0;
  font-family: 'Open Sans', sans-serif;
}



.sidenav-header {
  padding: 1.5rem;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 1rem;
}

.logo-img {
  max-height: 40px;
  width: auto;
}

.navbar-nav {
  padding: 0;
  margin: 0;
  list-style: none;
}

.nav-item {
  width: 100%;
}


.nav-link {
  display: flex;
  align-items: center;
  padding: 12px 16px;

  margin: 8px 15px;
  color: #d1d1d1;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
}


.nav-link:hover {
  color: #ffffff !important;
  text-decoration: none;
}


.nav-link.active {
  background: #C39B22 !important;
  color: #ffffff !important;

  margin: 8px 15px;
}

.nav-link i:not(.chevron) {
  width: 25px;
  font-size: 1.1rem;
  margin-right: 7px;
  text-align: center;
  color: #C39B22;
  transition: color 0.3s ease;
}

.nav-icon {
  margin-right: 10px;
  font-size: 1.2rem;
  color: #C39B22;
  transition: color 0.3s ease;
}

.nav-link.active .nav-icon {
  color: #fff;
}



.nav-link-text {
  flex: 1 1;
  font-weight: 600;
  font-size: 14px;
}

.chevron {
  font-size: 0.75rem;
  opacity: 0.6;
}


.sub-nav {
  list-style: none;
  padding: 0;
  background: rgba(0, 0, 0, 0.1);
}

.sub-nav-link {
  display: block;
  padding: 10px 10px 10px 57px;
  color: #adb5bd;
  text-decoration: none;
  font-size: 0.85rem;
}

.sub-nav-link:hover {
  color: #fff;
}

.sidenav-header img {
  display: block;
  /* margin-left: auto;
  margin-right: auto; */
  width: 60px;
}


@media (max-width: 991.98px) {
  .sidenav {
    position: fixed;
    left: -260px;
    top: 0;
    height: 100vh;
    z-index: 1050;
    transition: left 0.3s ease;
  }

  .sidenav.open {
    left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Sidebar/Sidebar.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,yBAAyB;AAC3B;;;AAGA;EACE,WAAW;EACX,WAAW;AACb;;;AAGA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;;;AAIA;EACE,eAAe;EACf,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;AACvC;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;;EAEzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;;;AAIA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd;uBACqB;EACrB,WAAW;AACb;;;AAGA;EACE;IACE,eAAe;IACf,YAAY;IACZ,MAAM;IACN,aAAa;IACb,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,OAAO;EACT;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n\n\n.layout-wrapper {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n  align-items: stretch;\n}\n\n\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  background-color: #f8f9fa;\n}\n\n\nheader {\n  width: 100%;\n  z-index: 10;\n}\n\n\n.main-content {\n  flex: 1;\n  padding:20px; \n  overflow-y: auto;\n  background: white;\n}\n\n\n.sidenav {\n  width: 260px;\n  height: auto;\n  position: sticky;\n  top: 0;\n  background: #0C1831;\n  flex-shrink: 0;\n  font-family: 'Open Sans', sans-serif;\n}\n\n\n\n.sidenav-header {\n  padding: 1.5rem;\n  text-align: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  margin-bottom: 1rem;\n}\n\n.logo-img {\n  max-height: 40px;\n  width: auto;\n}\n\n.navbar-nav {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.nav-item {\n  width: 100%;\n}\n\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n\n  margin: 8px 15px;\n  color: #d1d1d1;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border-radius: 12px;\n  font-family: 'Montserrat', sans-serif;\n}\n\n\n.nav-link:hover {\n  color: #ffffff !important;\n  text-decoration: none;\n}\n\n\n.nav-link.active {\n  background: #C39B22 !important;\n  color: #ffffff !important;\n\n  margin: 8px 15px;\n}\n\n.nav-link i:not(.chevron) {\n  width: 25px;\n  font-size: 1.1rem;\n  margin-right: 7px;\n  text-align: center;\n  color: #C39B22;\n  transition: color 0.3s ease;\n}\n\n.nav-icon {\n  margin-right: 10px;\n  font-size: 1.2rem;\n  color: #C39B22;\n  transition: color 0.3s ease;\n}\n\n.nav-link.active .nav-icon {\n  color: #fff;\n}\n\n\n\n.nav-link-text {\n  flex: 1;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.chevron {\n  font-size: 0.75rem;\n  opacity: 0.6;\n}\n\n\n.sub-nav {\n  list-style: none;\n  padding: 0;\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.sub-nav-link {\n  display: block;\n  padding: 10px 10px 10px 57px;\n  color: #adb5bd;\n  text-decoration: none;\n  font-size: 0.85rem;\n}\n\n.sub-nav-link:hover {\n  color: #fff;\n}\n\n.sidenav-header img {\n  display: block;\n  /* margin-left: auto;\n  margin-right: auto; */\n  width: 60px;\n}\n\n\n@media (max-width: 991.98px) {\n  .sidenav {\n    position: fixed;\n    left: -260px;\n    top: 0;\n    height: 100vh;\n    z-index: 1050;\n    transition: left 0.3s ease;\n  }\n\n  .sidenav.open {\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
